export const ThoughtMetrics = {
    async log(type, eventName, data) {
        let _tm
        if (window?.thoughtmetric) {
            _tm = window?.thoughtmetric
            await _tm(type, eventName, data)
        }
    },

    identity(customer) {
        this.log('identify', customer.id, {
            email: customer?.email,
            created_at: customer.date_created,
            first_name: customer?.first_name,
            last_name: customer?.last_name,
        })
    },

    async order(order) {
        const coupons = order.coupon_lines.map((coupon) => {
            return coupon.code
        })

        const items = order.line_items.map((item) => {
            return {
                product_name: item.name,
                quantity: item.quantity,
                unit_price: item.price,
            }
        })

        // items: [{ product_name: "Shoes", quantity: 1, unit_price: 49.00}]

        await this.log('event', 'order', {
            transaction_id: String(order.id),
            total_price: parseInt(order.total),
            currency: 'USD',
            orderCurrency: 'USD',
            subtotal_price: parseInt(order.total) - parseInt(order.total_tax),
            total_tax: parseInt(order.total_tax),
            total_shipping: parseInt(order.shipping_total),
            total_discounts: parseInt(order.discount_total),
            discount_codes: coupons,
            items: items,
        })
    },
    cart(cart) {
        this.log('event', 'addToCart', {
            total_price: cart.total,
            currency: 'USD',
            orderCurrency: 'USD',
        })
    },
    lead(lead) {
        this.log('event', 'lead', {
            lead_id: lead.email,
        })
    },
}
